import { Box, BoxProps, styled } from '@mui/material';

const StyledProgressContainer = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  height: '1.2rem',
  borderRadius: '1.2rem',
  backgroundColor: theme.palette.background.accordion,
  position: 'relative',
}));

export default StyledProgressContainer;
